/* eslint-disable no-unused-vars */
import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import map from '../static/map.png'
import {
  Header,
  HeaderParagraph,
  Product,
  Backgroundwrapper,
  Footer,
  OurClient,
  ProductDescription,
  BodyWrapper,
  MobileFooter,
  Input,
  Icon
} from '../components'
import { Element } from 'react-scroll'
import { Container, BigCircle, Font51, Font20 } from '../components/StyledComponents'
import { Helmet } from 'react-helmet'
const MobileClientLogo = styled.li``

const ButtonMLogo = styled.button`
  width: 138px;
  margin: auto;
  height: 38px;
  background: transparent;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  line-height: 1;
  color: #333333;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
  box-shadow: none;
  @media (min-width: 767px) {
    display: none;
`

const ContentWrapper = styled.div`
  max-width: 2560px;
  margin: 0 auto;
`

const SecondSection = styled.div`
  padding-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-bottom: 70px;
  & + div {
    & > img {
      max-width: 100%;
    }
  }
  & ~ div {
    padding-top: 80px;
  }
  @media (max-width: 768px) {
    & ~ div {
      padding-top: 0;
    }
    // margin-bottom: 30px;
  }
  & ~ div:nth-child(odd) {
    flex-direction: row-reverse;
    @media (max-width: 840px) {
      flex-direction: column;
      align-items: center;
    }
  }
  & ~ div:last-child {
  }
`
const CoreTeamWrapper = styled.div`
  padding: 10px 0 0px 0;
  max-width: 1366px;
  margin: 0 auto;
  & + section {
    & > p {
      max-width: 1366px;
      word-break: break-all;
    }
    & > button {
      margin-top: 14px;
    }
  }
  @media (max-width: 768px) {
    padding: 30px 0;
    & > p {
      text-align: center;
    }
  }
`
const ProductCards = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  max-width: 1366px;
  @media (max-width: 768px) {
    & > div {
      width: 33.333%;
      margin: 0px auto;
      padding: 10px;
    }
    @media (max-width: 520px) {
      & > div {
        width: 50%;
        margin: 0px auto;
      }
  }
`
const TeamMemberWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 80px;
  flex-wrap: wrap;
  max-width: 80%;
  margin: 0 auto;

  & > div {
    display: flex;
    width: 25%;
    flex-direction: column;
    & > div:first-child {
      height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      & > img {
        max-width: 190px;
      }
    }
    & > p:nth-child(2) {
      align-self: center;
      font-size: 20px;

      line-height: 1.52;
      text-align: center;
      color: #333333;
      margin: 0;
    }
    & > p:nth-child(3) {
      align-self: center;
      font-size: 16px;

      line-height: 1.63;
      letter-spacing: 0.1px;
      text-align: center;
      color: #999999;
      margin: 0;
    }
  }
  @media (max-width: 768px) {
    padding-top: 40px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    & > div {
      width: 33.33%;
      & > img {
        object-fit: cover;
      }
    }
  }
  @media (max-width: 640px) {
    padding-top: 40px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    & > div {
      width: 100%;
      & > img {
        object-fit: cover;
      }
    }
  }
`
const TeamWrapper = styled.section`
  max-width: 1366px;
  width: 100%;
  margin: 0 auto;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 40px;
    padding-bottom: 40px;
  }
  & + section {
    display: flex;
    flex-direction: column;
    align-items: center;
    & > p {
      padding-top: 10px;
    }
    & > button {
      margin-top: 30px;
    }
  }
`
const Container2 = styled.section`
  padding: ${props => (props.padding ? props.padding : '60px 80px')};
  background: ${props => (props.background ? props.background : '#fff')};
  display: flex;
  flex-direction: column;
  align-items: ${props => (props.normal ? 'center' : 'center')};
  margin: ${props => (props.margin ? props.margin : '0px')};
  width: 100%;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 40px 20px;
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`
const ContainerTitle = styled.h1`
  font-size: 38px;
  line-height: 1.21;
  text-align: ${props => (props.align ? props.align : 'center')};
  color: #333333;
  padding-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`
const TeamSection = styled.section`
  padding: 80px;
  & > div {
    padding-top: 80px;
    @media (max-width: 640px) {
      padding-top: 30px;
    }
    & > div > p:nth-child(3) {
      margin-bottom: 64px !important;
      @media (max-width: 640px) {
        margin-bottom: 20px !important;
      }
    }
  }
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 0;
  }
`
const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 992px) {
    flex-direction: column;
    width: 100%;
  }
  @media (max-width: 768px) {
    & > div {
      flex-basis: 100%;
      width: 100%;
    }
  }
`
const ContainerSubTitle = styled.p`
  font-size: 17px;
  font-weight: 300;
  line-height: 1.53;
  text-align: center;
  color: #999999;
  width: calc(100% - 0%);
  padding-left: 15%;
  padding-right: 15%;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  @media (max-width: 768px) {
    font-size: 16px;
    font-weight: 300;
    padding: 0;
    line-height: 1.63;
  }
  @media (max-width: 520px) {
  padding: 0;
`
const ContainerLeft = styled.div`
  flex-basis: calc(55% - 60px);
  padding-right: 60px;
  @media (max-width: 992px) {
    padding: 0;
    flex-basis: calc(100% - 0px);
  }
  & > p {
    font-size: 16px;
    line-height: 1.6;
    letter-spacing: 0.8px;
    color: #333333;
    padding-bottom: 4px;
    font-weight: 500;
  }
  & > p:nth-child(2) {
    font-size: 38px;
    font-weight: 400;
    line-height: 1.2;
    padding-bottom: 10px;
    letter-spacing: 2.4px;
    font-weight: 400;
    color: #333333;
    margin: 0;
  }
  & > p:nth-child(3) {
    // width: 448px;
    font-weight: 400;
    margin-bottom: 20px;
    color: #666666;
  }
  @media (max-width: 768px) {
    & > p {
      font-size: 14px;
    }
    & > p:nth-child(2) {
      font-size: 24px;
    }
  }
`
const ContainerRight = styled.div`
  flex-basis: 45%;
  & > div:first-child {
    display: none;
    @media (max-width: 768px) {
      display: block;
    }
  }
  & > div:last-child {
    display: block;
    @media (max-width: 768px) {
      padding-top: 30px;
    }
  }
`
const TopWrapper = styled.div`
  max-width: 1366px;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 40px 16px 20px;
    & > h1 {
      font-size: 28px !important;
      line-height: normal !important;
      letter-spacing: normal !important;
    }
    & > p {
      font-size: 16px !important;
      font-weight: 300 !important;
      line-height: 1.38 !important;
      letter-spacing: 0.1px !important;
    }
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 80px 250px 60px 80px;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  & > p {
    text-align: left;
    padding: 0;
    padding-top: 10px;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.61;
  }
  & > h1 {
    font-size: 48px;
    line-height: 1.27;
    color: #333333;
  }
`
const ImageWrapper = styled.div`
  & > img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
  @media (max-width: 768px) {
    & > img {
      height: 200px;
    }
  }
`
const FormWrapper = styled.form`
  display: flex;
  padding-top:20px;
  @media (max-width: 520px) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    & > div > input {
      width: 100%;
      margin-bottom: 10px;
    }
    & > button {
      width: 100%;
      border-radius 4px;
    }
  }
`
const ButtonComponent = styled.button`
  width: ${props => (props.width ? props.width : 186)}px;
  height: ${props => (props.height ? props.height : 48)}px;
  background: ${props => (props.background ? props.background : '#333333')};
  border-radius: ${props => (props.radius ? props.radius : '4px')};
  border: ${props => (props.border ? props.border : 'none')};
  line-height: 1;
  letter-spacing: 1px;
  color: ${props => (props.color ? props.color : '#fff')};
  cursor: pointer;
  text-transform: ${props => (props.transform ? props.transform : 'uppercase')};
  font-family: Montserrat;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 1px;
  box-shadow: ${props => (props.shadow ? props.shadow : 'none')};
  -webkit-tap-highlight-color: transparent;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
  }
  &:focus {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
    outline: none;
  }
  @media (max-width: 768px) {
    height: 38px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1.1px;
  }
`
const ContactFrom = styled.div`
  margin-top: 50px;
`
const FromGroup = styled.div`
  width: 100%;
  margin-right: 20px;
  margin: 8px;
  input,
  textarea {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    width: 100%;
  }
  input {
  }
  textarea {
    padding: 10px;
    min-height: 150px;
    :focus {
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
      outline: none;
    }
  }
`
const AddressWrap = styled.div`
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  margin-top: 20px;
  margin-left: 30px;

  @media (max-width: 768px) {
    margin-left: 0px;
  }
`
const AddressContent = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 0;
  a {
    color: #000;
  }
  > span {
    margin-right: 10px;
  }
  p {
    font-size: 14px;
    color: #555;
    font-weight: 500;
    margin-bottom: 5px;
  }
  p span {
    font-weight: bold;
    display: block;
    font-size: 16px;
    color: #000;
  }
`
export const Button = props => {
  return (
    <ButtonComponent
      color={props.color}
      height={props.height}
      width={props.width}
      background={props.background}
      border={props.border}
      radius={props.radius}
      {...props}>
      {props.title}
    </ButtonComponent>
  )
}

class DigitalMarketing extends Component {
  state = {
    collapse: false,
    MobileLogo: true,
    MobileLogoText: 'View More',
    selected: 'V'
  }
  MobileLogoButton = e => {
    this.setState({ MobileLogoText: this.state.MobileLogo ? 'Less' : '' })
    this.setState({ MobileLogo: !e })
  }
  constructor(props) {
    super(props)
    this.state = {
      email:
        this.props.location && this.props.location.search
          ? decodeURIComponent(this.props.location.search.split('=')[1])
          : ''
    }

    this.handleChange = this.handleChange.bind(this)
  }
  handleChange(event) {
    this.setState({ email: event.target.value })
  }
  render() {
    const { selected } = this.state
    console.log(selected)
    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Top Digital Marketing Companies in India | Digital Marketing Agency | 8om</title>
          <meta
            name="description"
            content="One of the top digital marketing companies in India with innovatory services and expansive experience as a digital marketing agency across various platforms."
          />
          <meta
            name="keywords"
            content="online marketing, internet marketing, digital marketing agency india, digital marketing company, online marketing agency"
          />
        </Helmet>
        <Header />
        <ContentWrapper>
          <Container>
            <TopWrapper>
              <HeaderParagraph
                headerColor={'#333333'}
                headerFontSize={'38px'}
                header={'Digital Marketing'}
                paragraph={
                  'Experts at 8OM formulate and dispense digital marketing strategies to boost your brand. Indulge in advanced business analysis with our services.'
                }
              />
            </TopWrapper>
            <ImageWrapper>
              <img src={require('../static/digitalmarketing.jpg')} alt="Services" />
            </ImageWrapper>
          </Container>
          <Element name="features">
            <Container padding={'80px 80px 50px 80px'} background="transparent">
              <Font51>Our Specialisation</Font51>
              <Font20>Let's have a look at how our organisation can bring you the best solutions.</Font20>
              <ProductCards>
                <ProductDescription
                  icon={'Serviceicon/Group23.png'}
                  title="SEO"
                  width="20"
                  description="SEO services and tactics that ensure your content’s top ranking."
                />
                <ProductDescription
                  icon={'Serviceicon/Group24.png'}
                  title="Google Adwords"
                  width="20"
                  description="Get discovered immediately as they search your products or services."
                />
                <ProductDescription
                  icon={'Serviceicon/Group25.png'}
                  title="Paid Marketing"
                  width="20"
                  description="With us increase your brand’s ROI at a faster phase tactically."
                />
                <ProductDescription
                  icon={'Serviceicon/Group26.png'}
                  title="ORM"
                  width="20"
                  description="We ensure a strong online presence at par with your efforts."
                />
                <ProductDescription
                  icon={'Serviceicon/Group32.png'}
                  title="Content Writing"
                  width="20"
                  description="Engaging content to build your audience's trust & influence them."
                />
                <ProductDescription
                  icon={'Serviceicon/Group31.png'}
                  title="Branding"
                  width="20"
                  description="We create a rare and remarkable identity for your brand."
                />
                <ProductDescription
                  icon={'Serviceicon/Group29.png'}
                  title="Graphic Design"
                  width="20"
                  description="Designs to boost your business by pros with the right tools."
                />
                <ProductDescription
                  icon={'Serviceicon/Group30.png'}
                  title="Logo Design"
                  width="20"
                  description="A luring and memorable first impression your brand deserves."
                />
                <ProductDescription
                  icon={'Serviceicon/Group28.png'}
                  title="Photography"
                  width="20"
                  description="Showcase the brand’s thought process with appealing visuals."
                />
                <ProductDescription
                  icon={'Serviceicon/Group27.png'}
                  title="Cinematography"
                  width="20"
                  description="Captivate the audience and inspire them with your ideation."
                />
                <ProductDescription
                  icon={'Serviceicon/Group33.png'}
                  title="Corporate Videos"
                  width="20"
                  description="Tell your brand’s stories creatively and strategically with us."
                />
                <ProductDescription
                  icon={'Serviceicon/Group35.png'}
                  title="Email marketing"
                  width="20"
                  description="Designs and write-ups that turn recipients into customers."
                />
                <ProductDescription
                  icon={'Serviceicon/Group39.png'}
                  title="Lead Generation"
                  width="20"
                  description="Always find your sales pipeline full of ideal prospects."
                />
                <ProductDescription
                  icon={'Serviceicon/Group36.png'}
                  title="Webinars"
                  width="20"
                  description="Our cutting-edge services help raise your brand awareness."
                />
                <ProductDescription
                  icon={'Serviceicon/Group37.png'}
                  title="Marketing Automation"
                  width="20"
                  description="Scale your efforts with optimised automation solutions."
                />
              </ProductCards>
            </Container>
          </Element>
          <Container background="#fffff" padding={'50px 0'}>
            <CoreTeamWrapper>
              <Element name="features">
                <Container padding={' 0px 80px 50px 80px'} background="transparent">
                  <Font51>Industries</Font51>
                  <Font20>We have sustained experience in various market sectors like these.</Font20>
                  <ProductCards>
                    <ProductDescription
                      icon={'Industries2/retail.png'}
                      title="Retail"
                      width="20"
                      description="Complementing your retail efforts, we step up your sales."
                    />
                    <ProductDescription
                      icon={'Industries2/eCommerce.png'}
                      title="eCommerce"
                      width="20"
                      description="A user centric approach leading them beyond the cart."
                    />
                    <ProductDescription
                      icon={'Industries2/Blockchain.png'}
                      title="Food & Beverages"
                      width="20"
                      description="We serve you, thereby, users conveniently access edibles."
                    />
                    <ProductDescription
                      icon={'Industries2/Manufacturing.png'}
                      title="Manufacturing"
                      width="20"
                      description="Demonstrate your services and products to the apt client."
                    />
                    <ProductDescription
                      icon={'Industries2/Health&Sustainability.png'}
                      title="Technology"
                      width="20"
                      description="Modern tech drives modern market which we utilise fully."
                    />
                  </ProductCards>
                </Container>
              </Element>
            </CoreTeamWrapper>
          </Container>
          <TopWrapper>
            <HeaderParagraph
              headerColor={'#333333'}
              headerFontSize={'38px'}
              header={'Get In Touch'}
              paragraph={'Sent us a message'}
            />

            <FlexContainer>
              <ContactFrom>
                <form action="https://formspree.io/harsh@8om.io" method="POST">
                  <FlexContainer>
                    <FromGroup>
                      <Input type="name" icon="user" name="Name" placeholder="Name" changeColor={'#35cc62'} required />
                    </FromGroup>
                    <FromGroup>
                      <Input
                        type="email"
                        name="_replyto"
                        icon="email"
                        placeholder="Email"
                        changeColor={'#35cc62'}
                        onChange={this.handleChange}
                        value={this.state.email}
                        required
                      />
                    </FromGroup>
                  </FlexContainer>
                  <FlexContainer>
                    <FromGroup>
                      <Input
                        type="phone"
                        name="contact"
                        icon="contact"
                        placeholder="Phone"
                        changeColor={'#35cc62'}
                        required
                      />
                    </FromGroup>
                  </FlexContainer>
                  <FlexContainer>
                    <FromGroup>
                      <textarea name="textarea" id="" placeholder="Your message type here" />
                    </FromGroup>
                  </FlexContainer>
                  <input type="hidden" name="_next" value="/" />
                  <FromGroup>
                    <Button type="submit" title="Submit" />
                  </FromGroup>
                </form>
              </ContactFrom>

              <AddressWrap>
                <AddressContent>
                  <span>
                    <Icon icon="contact" />
                  </span>
                  <p>
                    Phone
                    <span>
                      <a href="tel:+918076157787"> +91 8076157787</a>
                    </span>
                  </p>
                </AddressContent>
                <AddressContent>
                  <span>
                    <Icon icon="email" />
                  </span>
                  <p>
                    Email
                    <span>
                      <a href="mailto:harsh@8om.io"> harsh@8om.io</a>
                    </span>
                  </p>
                </AddressContent>
                <AddressContent>
                  <span>
                    <Icon icon="website" />
                  </span>
                  <p>
                    Website
                    <span>8om.io</span>
                  </p>
                </AddressContent>
                {/* <AddressContent>
                  <span>
                    <Icon icon="location" />
                  </span>
                  <p>
                    Location
                    <span>
                      3rd Floor, Plot No. 8 Balaji Estate,
                      <br /> Guru Ravidas Marg, Kalkaji,
                      <br /> New Delhi, Delhi 110019
                    </span>
                  </p>
                </AddressContent> */}
              </AddressWrap>
            </FlexContainer>
          </TopWrapper>
          <Container2 normal background={'#fafbfc'} padding={'80px 0 80px 0'}>
            <ContainerTitle>Our Clients Around The World</ContainerTitle>
            <ContainerSubTitle>
              Our clients are valuable to us and we’re always inspired by them and their need to make their business
              better.
            </ContainerSubTitle>
            <Backgroundwrapper>
              <OurClient>
                <ul>
                  <li>
                    <img src={require('../static/client_logo/baked-pizza.jpg')} alt="Baked" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/resplendentcosmetics.png')} alt="Resplendent Cosmetics" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/tanoshiitrail.png')} alt="Tanoshii Trail" />
                  </li>

                  <li>
                    <img src={require('../static/client_logo/m-tech.jpg')} alt="M-tech" />
                  </li>

                  <li>
                    <img src={require('../static/client_logo/munafamart.png')} alt="Munafamart" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/teafloor.png')} alt="Teafloor" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/vikas_spools.jpg')} alt="Vikas Spools" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/techrobotix.png')} alt="Techrobtix" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/phone.png')} alt="Phono Retail" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/bng.png')} alt="Blue n Greys" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/beccos.jpg')} alt="Beccos" />
                  </li>
                </ul>
              </OurClient>
            </Backgroundwrapper>
          </Container2>
        </ContentWrapper>
        <BodyWrapper>
          <Footer />
          <MobileFooter />
        </BodyWrapper>
      </Fragment>
    )
  }
}

export default withRouter(DigitalMarketing)



// WEBPACK FOOTER //
// ./src/pages/DigitalMarketing.js